import { render, staticRenderFns } from "./ResourcePreviewModal.vue?vue&type=template&id=628e597c&scoped=true"
import script from "./ResourcePreviewModal.vue?vue&type=script&lang=js"
export * from "./ResourcePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ResourcePreviewModal.vue?vue&type=style&index=0&id=628e597c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e597c",
  null
  
)

export default component.exports